<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import ChatMessage from './ChatMessage.vue';
    import ChatMessageRows from './ChatMessageRows.vue';
    import LoadingDots from '../LoadingDots.vue';
    import { onMounted, ref } from 'vue';

    const props = defineProps<{ message: IChatMessage }>();
    const visible = ref(false);

    onMounted(() => {
        console.log('New update!', props.message);
        visible.value = true;
    });
</script>

<template>
    <Transition name="slide">
        <ChatMessage
            v-if="visible"
            :message="message"
            class="px-4 py-1 bg-transparent"
            :rating="false"
            :timestamp="false"
        >
            <LoadingDots :color="false" class="justify-start mb-1.5" />
            <ChatMessageRows :message="message" />
        </ChatMessage>
    </Transition>
</template>
